// extracted by mini-css-extract-plugin
module.exports = {"TextArea":"TextArea_TextArea__3iqqC","Dark":"TextArea_Dark__1vY-1"};